import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useIsDesktopLayout } from './useMediaQuery';
import { setLayoutMode } from '../redux/actions/ui/layoutMode/index';

export const useSetLayoutMode = () => {
  const dispatch = useDispatch();
  const isDesktop = useIsDesktopLayout();

  useEffect(() => {
    dispatch(setLayoutMode(isDesktop));
  }, [dispatch, isDesktop]);
};
